module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_01.af7865a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_01.png
// module id = dmkL
// module chunks = 10